<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="クーポン発行"
        hide-footer
        @hidden="close">
        <user-coupon-code-form/>
    </b-modal>
</template>

<script>
export default {
    data: function () {
        return {
            modalShow: false,
        }
    },

    created: function () {
        bus.$on('open-modal-user-coupon-code', this.open)
        bus.$on('user-coupon-published', this.close)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-user-coupon-code')
        bus.$off('user-coupon-published')
    },

    methods: {
        /**
         * モーダルを表示
         */
        open: function() {
            this.modalShow = true
            setTimeout(() => document.getElementById('couponCodeInput').focus(), 300)
        },

        /**
         * モーダルを閉じる
         */
        close: function() {
            this.modalShow = false
        },
    },
}
</script>
